import styled from 'styled-components';

const ProgressBarWrapper = styled.div`
  .progress {
    height: 4px;
    background-color: ${({ theme }) => theme.colors.primary[600]};
    clip-path: polygon(0% 0%, 100% 0%, 97% 100%, 0% 100%);
    border-radius: 10px;
  }

  .completed {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
  }

  .block {
    background-color: rgba(236, 236, 236, 1);
    border-radius: 10px;
  }
`;

export default ProgressBarWrapper;
